import React, { useState, useEffect } from "react";
import { Modal, Form, Row, Col, Card } from "react-bootstrap";
import { useDropzone } from "react-dropzone";
import { publishImage } from "../../helpers/imageupload";
import { getAsset } from "../../helpers/helper";
import { SuccessNotify, FailedNotify } from "../../constants/tostify";
import { ClearIcon } from "@mui/x-date-pickers";
import { images } from "../../constants";
import url from "../../config/axios";

const UpdateCertificateeModal = ({ show, handleClose, updateid, serviceid }) => {
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const [displayimg, setDisplayimg] = useState([]);

  const [userdata, setUserData] = useState({
    name: "",
    issueDate: "",
    img: "" 
  });

  
  useEffect(() => {
    if (!updateid) return;

    url
      .get(
        `service/GetCertExpeSer/id/?id=${serviceid}&certificateid=${updateid}`
      )
      .then((res) => {
        const d = res?.data?.data?.item;

        const imgString = Array.isArray(d?.img) ? d.img[0] : d?.img || "";

        setUserData({
          name: d?.name || "",
          issueDate: d?.issueDate || "",
          img: imgString
        });

        setDisplayimg(imgString ? [imgString] : []);
      })
      .catch((err) => console.log(err));
  }, [updateid, serviceid]);

  // Input Change Handler
  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData((prev) => ({ ...prev, [name]: value }));
  };

  // Image Upload Handler
  const onDrop = async (acceptedFiles) => {
    try {
      setIsUploading(true);
      setUploadProgress(0);

      const uploaded = await publishImage(acceptedFiles, (percent) =>
        setUploadProgress(percent)
      );

      const imgString = Array.isArray(uploaded) ? uploaded[0] : uploaded;

      // Save only 1 image
      setUserData((prev) => ({ ...prev, img: imgString }));
      setDisplayimg([imgString]);
    } catch (error) {
      FailedNotify("Failed! Try Again");
    } finally {
      setIsUploading(false);
      setUploadProgress(0);
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    onDrop
  });

  // Remove Image
  const removeImage = () => {
    setDisplayimg([]);
    setUserData((prev) => ({ ...prev, img: "" }));
  };

  // PATCH API – Send Only String
  const UpdateUserdata = () => {
    const finalData = {
      ...userdata,
      img: userdata.img // always string already
    };

    url
      .patch(
        `service/updateSingleCertificate/id/?id=${serviceid}&certificateid=${updateid}`,
        finalData
      )
      .then((res) => {
        if (res.data.success) {
          handleClose();
          SuccessNotify("Certificate Updated Successfully");
        }
      })
      .catch(() => {
        FailedNotify("Failed to Update Try Again");
        handleClose();
      });
  };

  return (
    <Modal show={show === 8} onHide={handleClose} centered size="lg">
      <Modal.Header
        className="text-white pt-1 pb-1"
        style={{ backgroundColor: "#0353A4" }}
        closeButton
      >
        <Modal.Title>Update Certificate</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Row>
            <Col lg="6">
              <Form.Group className="mb-3">
                <Form.Label>Certificate Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Name"
                  name="name"
                  value={userdata.name}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>

            <Col lg="6">
              <Form.Group className="mb-3">
                <Form.Label>Issue Date</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Issue Date"
                  name="issueDate"
                  value={userdata.issueDate}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>

          <Form.Group className="mb-3">
            <Form.Label>Expiry Date (Optional)</Form.Label>
            <Form.Control type="text" placeholder="Expiry Date" />
          </Form.Group>

          {/* Image Upload */}
          <Col>
            <Row>
              <Col lg="9">
                <Row>
                  {/* Upload Box */}
                  <Col lg={3} className="mt-2 ms-1">
                    <Card
                      style={{
                        width: "6rem",
                        height: "6rem",
                        position: "relative"
                      }}
                      {...getRootProps()}
                    >
                      {isUploading ? (
                        <div
                          style={{
                            position: "absolute",
                            inset: 0,
                            background: "rgba(255,255,255,0.7)",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            flexDirection: "column"
                          }}
                        >
                          <div
                            className="spinner-border text-primary"
                            style={{ width: "1.5rem", height: "1.5rem" }}
                          ></div>
                          <small>{uploadProgress}%</small>
                        </div>
                      ) : (
                        <>
                          <Card.Img src={images.AddImage} className="imet-fit" />
                          <input
                            type="file"
                            {...getInputProps()}
                            style={{ display: "none" }}
                          />
                        </>
                      )}
                    </Card>
                  </Col>

                  {/* Preview */}
                  {displayimg.length > 0 && (
                    <Col lg={7} className="mt-1 d-flex">
                      {displayimg.map((image, index) => (
                        <Card
                          key={index}
                          className="me-2 mt-1"
                          style={{
                            width: "6rem",
                            height: "6rem",
                            border: "2px solid",
                            position: "relative"
                          }}
                        >
                          <Card.Img
                            className="imet-fit"
                            src={getAsset(image)}
                            crossOrigin="anonymous"
                          />

                          <div className="close-btnone" onClick={removeImage}>
                            <ClearIcon />
                          </div>
                        </Card>
                      ))}
                    </Col>
                  )}
                </Row>
              </Col>
            </Row>
          </Col>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <button
          className="pt-1 pb-1 ps-3 pe-3 font_11 rounded"
          onClick={handleClose}
          style={{
            backgroundColor: "white",
            border: "1px solid red",
            color: "red"
          }}
        >
          Cancel
        </button>

        <button
          className="pt-1 pb-1 ps-3 pe-3 font_11 rounded"
          onClick={UpdateUserdata}
          style={{
            backgroundColor: "#0353A4",
            border: "1px solid #0353A4",
            color: "white"
          }}
        >
          Save
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default UpdateCertificateeModal;
